import React from 'react'
import PropTypes from 'prop-types'
import UserConfirmationModal from './UserConfirmationModal'
import Join from './pages/Join'
import SupplierUserLocked from './pages/SupplierUserLocked'
import AgencyUserLocked from './pages/AgencyUserLocked'

class LockedModal extends React.Component {
  renderPage = ({ currentPage, close }) => {
    switch (currentPage) {
      case 'Join':
        return (
          <Join
            onSignIn={() => {
              close()
              $(`#${this.props.signInModalId}`).foundation('open')
            }}
            onSignUp={() => {
              close()
              $('#sign-up-modal').foundation('open')
            }}
          />
        )
      case 'SupplierUserLocked':
        return <SupplierUserLocked />
      case 'AgencyUserLocked':
        return <AgencyUserLocked supportEmail={this.props.supportEmail} />
    }
  }

  render () {
    let initialPage = 'Join'
    if (this.props.signedIn) {
      if (this.props.userType === 'supplier') {
        initialPage = 'SupplierUserLocked'
      } else {
        initialPage = 'AgencyUserLocked'
      }
    }

    return (
      <UserConfirmationModal
        render={this.renderPage}
        initialPage={initialPage}
        modalId={this.props.modalId}
      />
    )
  }
}

LockedModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  signInModalId: PropTypes.string.isRequired,
  supportEmail: PropTypes.string.isRequired
}

export default LockedModal
